import {CarouselPagination, Text, useTheme} from '@primer/react-brand/esm'
import {clsx} from 'clsx'

import {PlayButton} from '../../../../../../brand/components/PlayButton/PlayButton'

import {useHeroPagination} from './use-hero-pagination'
import type {HeroPaginationProps, HeroPaginationTab} from './types'

import Styles from './HeroPagination.module.css'

export type {HeroPaginationProps} from './types'

export const defaultProps: Partial<HeroPaginationProps> = {}

export const HeroPagination = (props: HeroPaginationProps) => {
  const initializedProps: HeroPaginationProps = {...defaultProps, ...props}
  const {currentChapterIndex, items, onChange, a11y, playback} = initializedProps
  const {colorMode} = useTheme()
  const {action, viewportRef, selectedButtonRef, progressRef, selectChapter, handlePlaybackClick} = useHeroPagination({
    currentChapterIndex,
    items,
    onChange,
    playback,
  })

  const getItemTab = (item: HeroPaginationTab, index: number) => {
    const isSelected = index === currentChapterIndex

    return (
      <li className={Styles['HeroPagination__chapters_item']} key={index}>
        <button
          type="button"
          className={Styles['HeroPagination__chapters_button']}
          aria-current={isSelected ? 'step' : undefined}
          ref={isSelected ? selectedButtonRef : undefined}
          onClick={() => selectChapter(index)}
        >
          {isSelected && (
            <span className={Styles['HeroPagination__chapters_progress']} ref={progressRef} aria-hidden="true" />
          )}
          <Text
            size="200"
            variant={isSelected ? 'default' : 'muted'}
            className={Styles['HeroPagination__chapters_label']}
          >
            {item.label}
          </Text>
        </button>
      </li>
    )
  }

  if (items.length === 0) return null

  return (
    <div className={clsx(Styles['HeroPagination'], colorMode === 'dark' && Styles['HeroPagination--dark'])}>
      <div className={Styles['HeroPagination__chapters']}>
        <div className={Styles['HeroPagination__chapters_viewport']} ref={viewportRef}>
          <ul className={Styles['HeroPagination__chapters_list']}>{items.map(getItemTab)}</ul>
        </div>
      </div>
      <div className={Styles['HeroPagination__controls']}>
        <div className={Styles['HeroPagination__controls_pagination']}>
          <CarouselPagination
            aria-label={a11y.pagination.title}
            itemCount={items.length}
            activeIndex={currentChapterIndex}
            loop
            onChange={selectChapter}
            labels={{
              previous: a11y.pagination.previous,
              next: a11y.pagination.next,
            }}
            itemAttributesBuilder={index => ({'aria-label': items[index]?.label})}
          />
        </div>
        <PlayButton
          action={action}
          onClick={handlePlaybackClick}
          label={a11y.playButton[action]}
          className={Styles['HeroPagination__playback']}
        />
      </div>
    </div>
  )
}
